<!--
 * @Author: Sephiroth·D·Kid
 * @Date: 2019-06-27 16:19:44
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-09 14:20:37
 * @Description: 官网首页
 -->

<template>
  <div class="m-company-info-wrapper">
    <div class="introduction-wrapper item-wrapper">
      <div class="title-wrapper">
        <p class="line"></p>
        <div class="title">
          <img src="https://files.jinr.com/jinr-index/img/introduction-it.png" alt="" />
          <span>公司介绍</span>
        </div>
        <p class="line"></p>
      </div>
      <div class="text-wrapper">
        <p>
          鲸鱼，是一个安全稳健的互联网金融信息服务平台。
        </p>
        <p>
          鲸鱼专注于互联网+金融模式，运用互联网技术解决金融服务中的用户需求。依托于多维度的大数据风控模型，致力为个人、中小微企业提供安全可靠的线上信贷及出借撮合服务。
        </p>
        <p>
          凭借自身技术，风控实力和专业的管理团队，鲸鱼在安全、合规的道路上稳步前行，将不断为最广大人民提供专业高效、安全稳健的金融服务。
        </p>
      </div>
    </div>
    <div class="item-wrapper">
      <div class="title-wrapper">
        <p class="line"></p>
        <div class="title">
          <img src="https://files.jinr.com/jinr-index/img/introduction-view.png" alt="" />
          <span>鲸鱼主张</span>
        </div>
        <p class="line"></p>
      </div>
      <div class="content-box">
        <div class="item">
          <img src="https://files.jinr.com/jinr-index/img/introduction-01.jpg" alt="" srcset="" />
          <div class="title">企业使命</div>
          <p>为广大人民提供安全稳健的普惠金融服务</p>
        </div>
        <div class="item">
          <img src="https://files.jinr.com/jinr-index/img/introduction-02.png" alt="" srcset="" />
          <div class="title">企业使命</div>
          <p>为广大人民提供安全稳健的普惠金融服务</p>
        </div>
        <div class="item">
          <img src="https://files.jinr.com/jinr-index/img/introduction-03.png" alt="" srcset="" />
          <div class="title">企业使命</div>
          <p>为广大人民提供安全稳健的普惠金融服务</p>
        </div>
      </div>
    </div>
    <div class="item-wrapper">
      <div class="title-wrapper">
        <p class="line"></p>
        <div class="title">
          <img src="https://files.jinr.com/jinr-index/img/introduction-qualification.png" alt="" />
          <span>鲸鱼资质</span>
        </div>
        <p class="line"></p>
      </div>
      <div class="content-box">
        <img
          class="content-img"
          src="https://files.jinr.com/jinr-index/img/introduction-04.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="less" scope>
.m-company-info-wrapper {
  display: block;
  padding: 0.2rem;
  box-sizing: border-box;
  .title-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 0 0.2rem;
    .line {
      flex: 1;
      border-top: 1px dashed #227af0;
      margin: 0 0.2rem;
    }
    .title {
      display: flex;
      align-items: center;
      img {
        width: 0.6rem;
      }
      span {
        font-size: 0.28rem;
        color: #3e8be8;
        margin-left: 0.1rem;
      }
    }
  }
  .text-wrapper {
    padding: 0 0.1rem;
    font-size: 0.24rem;
    p {
      text-indent: 2em;
      margin: 0.2rem 0;
    }
  }
  .item-wrapper {
    display: block;
    margin: 0.2rem auto 0.4rem;
    // width: 100%;
    .content-box {
      display: flex;
      align-items: flex-end;
      padding: 0.4rem 0.1rem 0.1rem;
      .item {
        display: flex;
        width: 3rem;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        img {
          width: 0.8rem;
          vertical-align: bottom;
        }
        .title {
          margin: 0.3rem 0;
          font-size: 0.26rem;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #575757;
        }
        p {
          text-align: center;
          font-size: 0.2rem;
        }
      }
      .content-img {
        width: 100%;
      }
    }
  }
}
</style>
